import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { LoaderService } from 'src/app/loader.service';
import { AUTHZ_FEATURES } from 'src/app/constants/permissions';
import { AuthzAccessHintService } from 'src/app/shared/authz-access-hint/authz-access-hint.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Pagination, Table } from 'src/app/shared/types';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
var LimitStoreListComponent = /** @class */ (function () {
    function LimitStoreListComponent(sharedService, loader, toastService, authzAccessHintService) {
        this.sharedService = sharedService;
        this.loader = loader;
        this.toastService = toastService;
        this.authzAccessHintService = authzAccessHintService;
        this.table = new Table({
            headers: {
                city: 'City',
                identifier: 'Identifier',
                identifierId: 'Name',
                limitType: 'Limit type',
                limit: 'Limit',
                warning: 'Warning',
                priority: 'Priority',
                active: 'Active'
            },
            pagination: new Pagination(0, 15, 0, [15, 20, 50]),
            sortableColumnKeys: ['city', 'identifier', 'identifierId', 'limitType', 'limit', 'priority', 'active'],
            data: []
        });
        this.showFilters = true;
        this.searchText = '';
        this.filterComponents = [];
        this.authzAccessHint = null;
        this.cities = [];
        this.cityNameToId = {};
        this.cityIdToName = {};
        this.serviceIdToName = {};
        this.shifts = [];
        this.services = [];
        this.allLimits = [];
        this.filteredLimits = [];
        this.appliedFilters = {};
        this.sortKey = '';
        this.citiesFilter = {
            type: 'searchable-dropdown',
            title: 'City',
            values: [],
            default: [],
            key: 'limit-city'
        };
        this.identifierFilter = {
            type: 'radio-button',
            title: 'Scope',
            name: 'limit-identifier',
            values: ['All', 'CITY', 'SHIFT', 'SERVICE'],
            default: 'All',
            key: 'limit-identifier'
        };
        this.limitTypeFilter = {
            type: 'radio-button',
            title: 'Limit type',
            name: 'limit-type',
            values: ['All', 'NEGATIVE_BALANCE', 'NEGATIVE_BALANCE_WARN', 'NEGATIVE_DUE_BALANCE', 'NEGATIVE_DUE_BALANCE_WARN'],
            default: 'All',
            key: 'limit-type'
        };
        this.activeFilter = {
            type: 'radio-button',
            title: 'Status',
            name: 'limit-active',
            values: ['All', 'Active', 'Inactive'],
            default: 'All',
            key: 'limit-active'
        };
        this.shiftsFilter = {
            type: 'searchable-dropdown',
            title: 'Shift',
            values: [],
            default: [],
            key: 'limit-shift'
        };
        this.servicesFilter = {
            type: 'searchable-dropdown',
            title: 'Service',
            values: [],
            default: [],
            key: 'limit-service'
        };
    }
    LimitStoreListComponent.prototype.ngOnInit = function () {
        this.loadAccessHint();
        this.refreshFilterComponents();
        this.fetchCities();
    };
    LimitStoreListComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData(AUTHZ_FEATURES.LIMIT_STORE)];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LimitStoreListComponent.prototype.onFilterChange = function (evt) {
        if (evt && evt['limit-city']) {
            this.loadCityDependents(evt['limit-city']);
        }
    };
    LimitStoreListComponent.prototype.applyFilters = function (filters) {
        this.appliedFilters = filters || {};
        this.table.pagination.pageNo = 0;
        this.fetchLimits();
    };
    LimitStoreListComponent.prototype.applySearch = function () {
        this.table.pagination.pageNo = 0;
        this.filterAndRender();
    };
    LimitStoreListComponent.prototype.renderPage = function () {
        this.renderTable();
    };
    LimitStoreListComponent.prototype.sortByHeader = function (header) {
        this.sortKey = header || '';
        this.filterAndRender();
    };
    LimitStoreListComponent.prototype.fetchCities = function () {
        var _this = this;
        this.loader.openLoading();
        this.sharedService.fetchCities().toPromise()
            .then(function (res) {
            _this.cities = ((res && res.data && res.data.cities) || [])
                .filter(function (city) { return city.active !== false; })
                .map(function (city) { return ({ id: city._id, name: city.displayName }); });
            _this.cityNameToId = {};
            _this.cityIdToName = {};
            _this.cities.forEach(function (city) {
                _this.cityNameToId[city.name] = city.id;
                _this.cityIdToName[city.id] = city.name;
            });
            _this.citiesFilter = Object.assign({}, _this.citiesFilter, {
                values: _this.cities.map(function (city) { return city.name; })
            });
            _this.refreshFilterComponents();
        })
            .catch(function () {
            _this.toastService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Error fetching cities'
            }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    LimitStoreListComponent.prototype.loadCityDependents = function (cityNames) {
        var _this = this;
        var names = (Array.isArray(cityNames) ? cityNames : []).filter(Boolean);
        if (!names.length) {
            this.shifts = [];
            this.services = [];
            this.serviceIdToName = {};
            this.patchShiftServiceFilters();
            return;
        }
        Promise.all(names.map(function (name) {
            var cityId = _this.cityNameToId[name];
            var shiftsPromise = _this.sharedService.fetchShifts(name).toPromise()
                .then(function (res) {
                var data = Array.isArray(res) ? res : (res && res.data ? res.data : []);
                return (data || []).filter(Boolean);
            })
                .catch(function () { return []; });
            var servicesPromise = cityId
                ? _this.sharedService.cityService(cityId).toPromise()
                    .then(function (res) { return ((res && res.data) || [])
                    .filter(function (sd) { return sd && sd.active !== false && sd.service; })
                    .map(function (sd) { return ({ id: sd.service._id, name: sd.service.name }); }); })
                    .catch(function () { return []; })
                : Promise.resolve([]);
            return Promise.all([shiftsPromise, servicesPromise]);
        })).then(function (results) {
            var shiftSeen = {};
            var shifts = [];
            var serviceSeen = {};
            var services = [];
            results.forEach(function (_a) {
                var cityShifts = _a[0], cityServices = _a[1];
                (cityShifts || []).forEach(function (shift) {
                    if (!shiftSeen[shift]) {
                        shiftSeen[shift] = true;
                        shifts.push(shift);
                    }
                });
                (cityServices || []).forEach(function (svc) {
                    if (svc.id && !serviceSeen[svc.id]) {
                        serviceSeen[svc.id] = true;
                        services.push(svc);
                    }
                });
            });
            _this.shifts = shifts;
            _this.services = services;
            _this.serviceIdToName = {};
            services.forEach(function (svc) {
                _this.serviceIdToName[svc.id] = svc.name;
            });
            _this.patchShiftServiceFilters();
            _this.filterAndRender();
        });
    };
    LimitStoreListComponent.prototype.patchShiftServiceFilters = function () {
        this.shiftsFilter = Object.assign({}, this.shiftsFilter, { values: this.shifts.slice() });
        this.servicesFilter = Object.assign({}, this.servicesFilter, {
            values: this.services.map(function (svc) { return svc.name; })
        });
        this.refreshFilterComponents();
    };
    LimitStoreListComponent.prototype.refreshFilterComponents = function () {
        this.filterComponents = [
            this.citiesFilter,
            this.identifierFilter,
            this.limitTypeFilter,
            this.activeFilter,
            this.shiftsFilter,
            this.servicesFilter
        ];
    };
    LimitStoreListComponent.prototype.selectedCityIds = function () {
        var _this = this;
        var names = this.appliedFilters['limit-city'] || [];
        return (Array.isArray(names) ? names : [])
            .map(function (name) { return _this.cityNameToId[name]; })
            .filter(Boolean);
    };
    LimitStoreListComponent.prototype.fetchLimits = function () {
        var _this = this;
        var cityIds = this.selectedCityIds();
        if (!cityIds.length) {
            this.toastService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Select a city to list limits'
            }));
            this.showFilters = true;
            return;
        }
        var queries = this.buildQueries(cityIds);
        if (!queries.length) {
            this.allLimits = [];
            this.filterAndRender();
            return;
        }
        this.loader.openLoading();
        Promise.all(queries.map(function (query) { return _this.sharedService.fetchLimits(query).toPromise(); }))
            .then(function (responses) {
            var merged = [];
            (responses || []).forEach(function (res) {
                var rows = Array.isArray(res) ? res : (res && res.data ? res.data : []);
                (rows || []).forEach(function (row) { return merged.push(row); });
            });
            _this.allLimits = _this.dedupeLimits(merged);
            _this.filterAndRender();
        })
            .catch(function (error) {
            _this.allLimits = [];
            _this.filterAndRender();
            var body = error && error.error;
            _this.toastService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: (body && body.message) || 'Error fetching limits'
            }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    LimitStoreListComponent.prototype.buildQueries = function (cityIds) {
        var identifier = this.appliedFilters['limit-identifier'] || 'All';
        var selectedShifts = this.appliedFilters['limit-shift'] || [];
        var selectedServiceNames = this.appliedFilters['limit-service'] || [];
        var selectedServiceIds = this.services
            .filter(function (svc) { return selectedServiceNames.indexOf(svc.name) >= 0; })
            .map(function (svc) { return svc.id; });
        var queries = [];
        var includeCity = identifier === 'All' || identifier === 'CITY';
        var includeShift = identifier === 'All' || identifier === 'SHIFT';
        var includeService = identifier === 'All' || identifier === 'SERVICE';
        if (includeCity) {
            queries.push({ identifier: 'CITY', identifierIds: cityIds });
        }
        if (includeShift) {
            var shiftIds = selectedShifts.length ? selectedShifts : this.shifts;
            if (shiftIds.length) {
                queries.push({ identifier: 'SHIFT', identifierIds: shiftIds });
            }
        }
        if (includeService) {
            var serviceIds = selectedServiceIds.length ? selectedServiceIds : this.services.map(function (svc) { return svc.id; });
            if (serviceIds.length) {
                queries.push({ identifier: 'SERVICE', identifierIds: serviceIds });
            }
        }
        return queries;
    };
    LimitStoreListComponent.prototype.dedupeLimits = function (rows) {
        var seen = {};
        return (rows || []).filter(function (row) {
            var key = [
                row.identifier,
                row.identifierId,
                row.limitType,
                row.city,
                row.limit,
                row.priority
            ].join('|');
            if (seen[key]) {
                return false;
            }
            seen[key] = true;
            return true;
        });
    };
    LimitStoreListComponent.prototype.filterAndRender = function () {
        var _this = this;
        var limitType = this.appliedFilters['limit-type'] || 'All';
        var active = this.appliedFilters['limit-active'] || 'All';
        var search = (this.searchText || '').trim().toLowerCase();
        var cityIds = this.selectedCityIds();
        this.filteredLimits = this.allLimits.filter(function (row) {
            if (cityIds.length && cityIds.indexOf(row.city) < 0) {
                return false;
            }
            if (limitType !== 'All' && row.limitType !== limitType) {
                return false;
            }
            if (active === 'Active' && !row.active) {
                return false;
            }
            if (active === 'Inactive' && row.active) {
                return false;
            }
            if (search) {
                var haystack = [
                    row.identifier,
                    row.identifierId,
                    _this.identifierName(row),
                    row.limitType,
                    row.limit,
                    row.city,
                    _this.cityIdToName[row.city],
                    row.metadata && row.metadata.negativeBalanceWarn
                ].join(' ').toLowerCase();
                if (haystack.indexOf(search) < 0) {
                    return false;
                }
            }
            return true;
        });
        if (this.sortKey) {
            var desc_1 = this.sortKey.charAt(0) === '-';
            var key_1 = desc_1 ? this.sortKey.slice(1) : this.sortKey;
            this.filteredLimits.sort(function (a, b) {
                var av = _this.sortValue(a, key_1);
                var bv = _this.sortValue(b, key_1);
                if (av === bv) {
                    return 0;
                }
                if (av > bv) {
                    return desc_1 ? -1 : 1;
                }
                return desc_1 ? 1 : -1;
            });
        }
        this.table.pagination.count = this.filteredLimits.length;
        this.renderTable();
    };
    LimitStoreListComponent.prototype.sortValue = function (row, key) {
        if (key === 'city') {
            return (this.cityIdToName[row.city] || row.city || '').toString().toLowerCase();
        }
        if (key === 'identifierId') {
            return this.identifierName(row).toLowerCase();
        }
        if (key === 'warning') {
            return row.metadata && row.metadata.negativeBalanceWarn;
        }
        var value = row[key];
        return value == null ? '' : value;
    };
    LimitStoreListComponent.prototype.renderTable = function () {
        var _this = this;
        var pageNo = this.table.pagination.pageNo || 0;
        var perPage = this.table.pagination.perPage || 15;
        var start = pageNo * perPage;
        var pageRows = this.filteredLimits.slice(start, start + perPage);
        this.table.data = pageRows.map(function (row) { return ({
            identifier: row.identifier || '--',
            identifierId: _this.identifierName(row),
            limitType: row.limitType || '--',
            limit: row.limit != null ? String(row.limit) : '--',
            warning: row.metadata && row.metadata.negativeBalanceWarn != null
                ? String(row.metadata.negativeBalanceWarn)
                : '--',
            city: _this.cityIdToName[row.city] || row.city || '--',
            priority: row.priority != null ? String(row.priority) : '--',
            active: row.active ? 'Active' : 'Inactive'
        }); });
    };
    LimitStoreListComponent.prototype.identifierName = function (row) {
        var id = row && row.identifierId;
        if (!id) {
            return '--';
        }
        if (row.identifier === 'CITY') {
            return this.cityIdToName[id] || '--';
        }
        if (row.identifier === 'SERVICE') {
            return this.serviceIdToName[id] || '--';
        }
        return String(id);
    };
    return LimitStoreListComponent;
}());
export { LimitStoreListComponent };
